<div class="disclaimer-wrapper">
  <div class="selector-div-wrapper">
    <span>Mostrar</span>
    <div class="form-check form-switch">
      <input
        class="input-switch-sm form-check-input"
        type="checkbox"
        role="switch"
        id="searcher-switch"
        [(ngModel)]="tool.enabled"
        [checked]="tool.enabled" />
    </div>
  </div>
  <div *ngIf="tool.enabled" class="tool-enabled-wrapper">
    <app-disclaimer-generator [tool]="tool"></app-disclaimer-generator>
  </div>
</div>
<div class="tabs-bottom">
  <button class="btn-secondary-action" (click)="save()">Aplicar cambios</button>
</div>
